// Todo create list of Routes for the AU/NZ/NSW WebApps
export const AppRoutes = {
  ContactUs: "/help-and-support/contact-us",
  Developer: "/developer",
  VolunteerSoftwareIntegrations: "/volunteer-software-integrations",
} as const;

export type AppRoutesType = typeof AppRoutes[keyof typeof AppRoutes];
